import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "../../../Containers/ContainerCreate";
import { getChimneyProfileTopTen } from "../../../api/getChimneyProfile";
import Spinner from "react-bootstrap/Spinner";

class ChimneyProfileTopTenContainer extends React.Component {
  componentDidMount() {
    const { chimDir } = this.props;
    this.props.request(chimDir);
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const topten = (data && data.data) || [];
    if (loading) {
      return <Spinner animation="border" variant="secondary" />;
    }
    if (!loading && topten.length === 0) {
      return null;
    }
    return render({ topten, loading, failure });
  };
}

ChimneyProfileTopTenContainer.propTypes = {
  chimDir: PropTypes.string.isRequired
};

export default CreateContainer(getChimneyProfileTopTen, ChimneyProfileTopTenContainer);
